<template>
    <section class="cnc-services-section">
        <div class="container">
            <h2 class="section-title">Our CNC Machining Services</h2>
            <div class="services-grid">
                <div class="service-card" v-for="(item, index) in serviceList" :key="index">
                    <div class="card-image">
                        <img :src="item.image" :alt="item.title" />
                    </div>
                    <div class="card-content">
                        <h3 class="card-title">{{ item.title }}</h3>
                        <p class="card-desc">{{ item.desc }}</p>
                    </div>
                </div>
            </div>

            <div class="action-buttons">
                <button class="btn-primary" @click="$router.push('/quote')">Get Instant Quote</button>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Services',
    setup() {
        const serviceList = [
            {
                image: require('@/assets/images/h1.png'),
                title: 'CNC Milling Services',
                desc: '3, 4 and 5-axis machining capabilities for simple and complex geometries.',
            },
            {
                image: require('@/assets/images/h2.png'),
                title: 'CNC Turning Services',
                desc: 'Standard and live tooling capabilities for cylindrical parts such as pins, shafts, and spacers.',
            },
            {
                image: require('@/assets/images/h3.png'),
                title: 'Electrical Discharge Machining (EDM)',
                desc: 'Wire and Sinker EDM are non-contact machining methods for cutting deep pockets, complex internal features, and holes with micro precision and sharp internal corners.',
            },
            {
                image: require('@/assets/images/h4.png'),
                title: 'Gear Hobbing Services',
                desc: 'A wide range of stock hobbing tools available for quick turnaround times.',
            },
            {
                image: require('@/assets/images/h5.png'),
                title: 'High Volume CNC Machining Services for Production Parts',
                desc: 'Serving all your CNC needs up to production quantities, including finishing and machining—all from your 2D drawings.',
            },
            {
                image: require('@/assets/images/h6.png'),
                title: 'Large CNC Parts',
                desc: 'Custom large CNC parts at scale, ensuring repeatability and reliable quality.',
            },
        ]

        return { serviceList }
    },
}
</script>

<style scoped>
.cnc-services-section {
    width: 100% !important;
    background-color: #f0f3f4 !important;
    padding: clamp(40px, 6vw, 76px) 20px; /* ✨ 动态内边距：在手机上自动缩小 padding */
    position: relative !important;
    z-index: 1;
}
.container {
    max-width: 1200px;
    margin: 0 auto !important;
    width: 100%;
    display: block;
}

.section-title {
    /* ✨ 动态标题字号：手机上24px，电脑上29px */
    font-size: clamp(24px, 4vw, 29px) !important; 
    font-weight: 600 !important;
    color: #444 !important;
    text-align: center;
    margin-bottom: 30px;
    position: relative;
}

.services-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-bottom: 40px;
    grid-auto-rows: 1fr;
    width: 100%;
    box-sizing: border-box;
}

.service-card {
    background: #fff;
    border-radius: 0;
    overflow: hidden;
    border: 1px solid #e8e8e8;
    transition: box-shadow 0.2s ease;
    display: flex;
    flex-direction: column;
    height: 100%;
    cursor: pointer;
    box-sizing: border-box;
}

.service-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.card-image {
    width: 100%;
    /* ✨ 核心修改：移除固定的 height: 254px，改用 aspect-ratio 比例 */
    /* 16 / 10 约等于原来的比例，图片会随着屏幕大小完美等比缩放 */
    aspect-ratio: 16 / 10; 
    overflow: hidden;
    flex-shrink: 0;
}

.card-image img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* 保证图片充满容器且不变形 */
    display: block;
}

.card-content {
    padding: 20px;
    display: flex;
    flex-direction: column;
    flex: 1;
}

.card-title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 1.3;
    flex-shrink: 0;
    height: 42px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 8px; /* 加一点底部间距 */
}

.card-desc {
    font-size: 15px; /* 移动端稍微软一点的字号 */
    color: #6b7280;
    font-weight: 500; /* 去掉 600，让描述文字和标题有层次感 */
    line-height: 1.6;
    margin-bottom: 0px;
}

.action-buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    width: 100%;
    box-sizing: border-box;
}

.btn-primary {
    padding: 12px 30px;
    border: none;
    background: #16bc9c !important;
    color: #fff !important;
    font-size: 16px;
    font-weight: 600;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.2s ease;
}

.btn-primary:hover {
    background: #13a68a !important;
}

/* ✨ 响应式断点控制 */
@media (max-width: 992px) {
    .services-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 640px) {
    .services-grid {
        grid-template-columns: 1fr; /* 手机端单列显示 */
    }
    
    /* 手机端进一步优化图片比例，避免占屏幕太高 */
    .card-image {
        aspect-ratio: 16 / 9; 
    }

    .action-buttons {
        flex-direction: column;
        width: 100%;
    }
    .btn-primary {
        width: 100%;
        justify-content: center;
    }
}
</style>